import type { MenuProps as RcMenuProps } from 'rc-menu';
import React from 'react';

interface IMenuContext {
  selectedKeys?: RcMenuProps['selectedKeys'];
  selectMode?: 'single' | 'multi';
}

const MenuContext = React.createContext<IMenuContext>({});

export const MenuContextProvider = MenuContext.Provider;
export const MenuContextConsumer = MenuContext.Consumer;
export const useMenuContext = () => React.useContext(MenuContext);
